import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { User } from '../models/user.model';
import { LoginData, otpDetails } from '../interfaces/index';
import { URLS } from '../constants/url.constants';
import { DefaultHttpHeaderOptions } from './httpDefaultHeaderOptions.service';
import { SnackService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user = new BehaviorSubject<User>(null);
  private tokenExpirationTimer: any;
  private _defaultHeaderOptions: object;
  private _baseUrl: string;
  private currentRole: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private _snackService: SnackService,
    private defaultHeaderOptions: DefaultHttpHeaderOptions
  ) {
    this._baseUrl = defaultHeaderOptions.baseUrl;
    this._defaultHeaderOptions = defaultHeaderOptions.baseRequestOptions();
  }

  login(loginData: LoginData): Observable<any> {
    const url = this._baseUrl.concat(URLS.auth.login);
    console.log('url',this._defaultHeaderOptions)

    return this.http.post(url,
      { username: loginData.username, password: loginData.password, role: loginData.role },
      this._defaultHeaderOptions
      )
      .pipe(catchError(this.handleError), tap(resData => {
        console.log(resData,'data')


        if (resData.body.data.status === 'verified_user') {
          const data = resData.body.data;
          console.log(data,'data')
          const userData = data.info;
          const token = data.token;
          this.currentRole = userData.role;
          localStorage.setItem('temp_number'+userData.role, userData.id);
          const expirationDate = new Date(+data.token_expiration_time * 1000);

          const user = new User(
            userData.name,
            userData.last_name,
            userData.email,
            userData.profileImage,
            userData.gender,
            userData.role,
            userData.timezone,
            userData.is2FA,
            token,
            expirationDate
            
          );

          const expirationDuration = expirationDate.getTime() - user.currentUTCTime.getTime();

          this.autoLogout(expirationDuration);

          this.user.next(user);
          localStorage.setItem('userData'+this.currentRole, JSON.stringify(user));
        } else  if (resData.body.data.status === 'OTP_SENT') {
          this._snackService.openSnackBar("success", resData.body.message);
        } else {
          return resData;
        }
      }));
  }

  refreshToken(val: any,currentRole?:any) {

    this.currentRole = currentRole;
    const userData: {
      last_name: string;
      is2FA: Boolean;
      name: string;
      email: string;
      profileImage: string;
      gender: string;
      role: string;
      timezone: any,
      _token: string;
      _tokenExpirationDate: Date;
    } = JSON.parse(localStorage.getItem('userData'+this.currentRole));

    if (!userData) {
      return;
    }

    const token = val.token;
    const expirationDate = new Date(+val.token_expiration_time * 1000);

    const loadedUser = new User(
      userData.name,
      userData.last_name,
      userData.email,
      userData.profileImage,
      userData.gender,
      userData.role,
      userData.timezone,
      userData.is2FA,
      token,
      expirationDate
    );

      this.user.next(loadedUser);
      const expirationDuration = expirationDate.getTime() - loadedUser.currentUTCTime.getTime();
      this.autoLogout(expirationDuration);
      localStorage.setItem('userData'+userData.role, JSON.stringify(loadedUser));

  }

 getAllUsers(): Observable<any> {
  const url = this._baseUrl.concat(URLS.users.getUsersList);
  return this.http.get(url, this._defaultHeaderOptions);
}

// getFormList(user_id: string): Observable<any> {
//   const url = this._baseUrl.concat(URLS.users.getFormList);

//   return this.http.post(url, { user_id }, this._defaultHeaderOptions).pipe(
//     catchError(this.handleError),
//     tap(resData => {
//       return resData;
//     })
//   );
// } 

getFormList(userId: string): Observable<any> {
  const url = this._baseUrl + 'viewform/' + userId;

  return this.http.post(url, {}, this._defaultHeaderOptions).pipe(
    catchError(this.handleError),
    tap(res => res)
  );
}

uploadFile(uploadData: FormData): Observable<any> {
  const url = this._baseUrl.concat(URLS.users.uploadFile);

  // Retrieve client user data from localStorage
  const userDataRaw = localStorage.getItem('userData' + 'client');
  const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
  const bearer_token: string = _.get(userData, '_token', '');

  // Construct headers WITHOUT setting 'Content-Type'
  const headers = new HttpHeaders({
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${bearer_token}`,
    'x-api-key': 'MktMO8tCAKkh2YGNLKIU11vHh5062QUKZ'
  });

  return this.http.post(url, uploadData, { headers }).pipe(
    catchError(this.handleError),
    tap((resData: any) => {
      if (!resData?.success) {
        throw new Error(resData?.message || 'Upload failed');
      }
    })
  );
}


sendRemovedFiles(removeData: Object): Observable<any> {
  const url = this._baseUrl.concat(URLS.master.removeFiles);

  // Retrieve client user data from localStorage
  const userDataRaw = localStorage.getItem('userData' + 'client');
  const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
  const bearer_token: string = _.get(userData, '_token', '');

  // Construct headers WITHOUT setting 'Content-Type'
  const headers = new HttpHeaders({
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${bearer_token}`,
    'x-api-key': 'MktMO8tCAKkh2YGNLKIU11vHh5062QUKZ'
  });

  return this.http.post(url, removeData, { headers }).pipe(
    catchError(this.handleError),
    tap((resData: any) => {
      if (!resData?.success) {
        throw new Error(resData?.message || 'removeFile failed');
      }
    })
  );
}

sendFactorAuthentication(factorAuhetication: Object): Observable<any> {
  const url = this._baseUrl.concat(URLS.master.factorAuthentication);

  // Retrieve client user data from localStorage
  const userDataRaw = localStorage.getItem('userData' + 'client');
  const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
  const bearer_token: string = _.get(userData, '_token', '');

  // Construct headers WITHOUT setting 'Content-Type'
  const headers = new HttpHeaders({
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': `Bearer ${bearer_token}`,
    'x-api-key': 'MktMO8tCAKkh2YGNLKIU11vHh5062QUKZ'
  });

  return this.http.post(url, factorAuhetication, { headers }).pipe(
    catchError(this.handleError),
    tap((resData: any) => {
      if (!resData?.success) {
        throw new Error(resData?.message || 'Some Error in Authentication');
      }
    })
  );
}

  autoLogin(currentRole?:string) {




    this.currentRole = currentRole;
    const userData: {
      last_name: string;
      is2FA: Boolean;
      name: string;
      email: string;
      profileImage: string;
      gender: string;
      role: string;
      timezone: any,
      _token: string;
      _tokenExpirationDate: Date;
    } = JSON.parse(localStorage.getItem('userData'+ this.currentRole ));

    console.log(userData)

    if (!userData) {
      return;
    }

  

    const loadedUser = new User(
      userData.name,
      userData.last_name,
      userData.email,
      userData.profileImage,
      userData.gender,
      userData.role,
      userData.timezone,
      userData.is2FA,
      userData._token,
      new Date(userData._tokenExpirationDate)
    );

    console.log(loadedUser.token,'loadedUser.token')

    if (loadedUser.token) {


      this.user.next(loadedUser);

      const expirationDuration = new Date(userData._tokenExpirationDate).getTime() - loadedUser.currentUTCTime.getTime();

      this.autoLogout(expirationDuration);
    }
  }

  logout() {
    this.user.next(null);
    localStorage.removeItem('userData'+this.currentRole);
    localStorage.removeItem('currentApp'+this.currentRole);
    localStorage.removeItem('temp_number'+this.currentRole);
    localStorage.removeItem('userData');

    localStorage.removeItem('userA2ZData');
    localStorage.removeItem('userHospitalData');
    sessionStorage.removeItem('parent');
    this.tokenExpirationTimer = null;

    this.router.navigate(['auth/login']);
  }

  autoLogout(expirationDuration: number) {

    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer);
    }
    this.tokenExpirationTimer = setTimeout(() => {
      this.logout();
    }, expirationDuration);
  }

  private handleError(errorResponse: HttpErrorResponse) {
    const errorMessage = 'An unknown error occured';
    if (!errorResponse.error || !errorResponse.error.message) {
      return throwError(errorMessage);
    }
    return throwError(errorResponse.error.message);
  }

  forgotpassword(forgotPasswordData: otpDetails): Observable<any> {
    const url = this._baseUrl.concat(URLS.auth.forgotpassword);

    return this.http.post(url, {
      email: forgotPasswordData.email,
      role: forgotPasswordData.role
    },this._defaultHeaderOptions)
      .pipe(catchError(this.handleError), tap(resData => {
        return resData;
      }));
  }

  otpVerify(forgotPasswordData: otpDetails): Observable<any> {
    const url = this._baseUrl.concat(URLS.auth.otpVerfiy);

    return this.http.post(url, {
      role: forgotPasswordData.role,
      action: forgotPasswordData.action,
      otp: forgotPasswordData.otp,
      verify_mode: forgotPasswordData.verify_mode,
      password: forgotPasswordData.password,
      email: forgotPasswordData.email,
      username: forgotPasswordData.username,
    }, this._defaultHeaderOptions)
      .pipe(catchError(this.handleError), tap(resData => {

        if (resData.body.data.status == 'OTP_VERIFIED') {
          const data = resData.body.data;
          const userData = data.info;
          const token = data.token;
          const expirationDate = new Date(+data.token_expiration_time * 1000);

          const user = new User(
            userData.name,
            userData.last_name,
            userData.email,
            userData.profileImage,
            userData.gender,
            userData.role,
            userData.timezone,
            userData.is2FA,
            token,
            expirationDate
          );

          this.user.next(user);
          localStorage.setItem('userData'+userData.role, JSON.stringify(user));
        }
      }));
  }
}

